import { getUA } from 'mobile-device-detect';
import comService from '@/services/comService';
import mmsService from '@/services/mmsService';
import mbcService from '@/services/mbcService';
import store from '../store/index';
import router from '../route/router';

export default {
  // 取得Cookie值
  getCookie(cookieName) {
    const name = `${cookieName}=`;
    const cookies = document.cookie.split(';');
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < cookies.length; i++) {
      const c = cookies[i].trim();
      if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return null;
  },
  // 設置Cookie
  setCookie(cookieName, cookieValue) {
    document.cookie = `${cookieName}=${cookieValue}; path=/`;
  },
  // 使Cookie失效
  deleteCookie(cookieName) {
    document.cookie = `${cookieName}=; path=/; expires=${Date.now()}`;
  },
  // 登入
  login(path, query) {
    let params = {
      companyid: store.state.companyId,
      membersourceid: store.state.memberSourceId,
    };

    if (query) params = Object.assign(params, query);
    const queryString = new URLSearchParams(params).toString();

    // 以 line 瀏覽器、Liff 開啟
    if (getUA.match(/line/igm) || getUA.match(/liff/igm)) {
      const comUrl = JSON.parse(process.env.VUE_APP_USE_ENV) ? '${VUE_APP_API_COM_URL}' : process.env.VUE_APP_API_COM_URL;
      const mbcUrl = JSON.parse(process.env.VUE_APP_USE_ENV) ? '${VUE_APP_API_MBC_URL}' : process.env.VUE_APP_API_MBC_URL;
      const redirectUrl = encodeURIComponent(`${window.location.origin}${path}__${queryString.replace(/&/igm, '__')}`);
      const myParam = `${store.state.companyId}*${redirectUrl}`;

      // 跳轉至 SSO 綁定頁
      window.location.href = `${comUrl}api/v1/linecode?DirectUrl=${mbcUrl}api/v1/uri-bind-service?myparam=${myParam}&CompanyId=${store.state.companyId}`;
    } else {
      const ssoUrl = JSON.parse(process.env.VUE_APP_USE_ENV) ? '${VUE_APP_API_SSO_URL}' : process.env.VUE_APP_API_SSO_URL;
      const redirectUrl = encodeURIComponent(`${window.location.origin}${path}?${queryString}`);

      // 跳轉至 SSO 登入頁
      window.location.href = `${ssoUrl}login?openExternalBrowser=1&${queryString}&redirect_url=${redirectUrl}`;
    }
  },
  // 檢查是否為好友、發訊息
  checkFriendAndSendLineMessage(accountId, companyId, unionId) {
    const vm = this;
    const body = {
      companyID: companyId,
      openID: accountId,
    };

    return comService.checkLineOfficeAccountFriend(body)
      .toPromise()
      // 是好友 > 發訊息
      .then(() => vm.sendLineMessage({ accountId, companyId, unionId }))
      .catch((err) => {
        // 非好友
        if (err.data.status === '605') {
          // 新增未完成事項
          mmsService.createQrCodePendingJob({ accountId, unionId })
            .toPromise()
            .then((res) => {
              router.replace({ name: 'Blank', params: { status: 'redirectOfficalAccount', redirectUrl: res.response.data[0].redirectUrl } });
            })
            .catch(() => {
              router.replace({ name: 'Error', params: { status: 'unstableNetwork' } });
            });

          return;
        }

        // 其他無法辨認是否為好友情況 > 發訊息
        vm.sendLineMessage({ accountId, companyId, unionId });
      });
  },
  // 發送 Line 訊息
  sendLineMessage(body) {
    // QR Code 行銷活動發送 Line 訊息
    return mmsService.postQrCodeLineMessage(body)
      .toPromise()
      .then((res) => {
        router.replace({ name: 'Blank', params: { status: 'redirectOfficalAccount', redirectUrl: res.response.data[0].redirectUrl } });
      })
      .catch((err) => {
        // QR Code 資料不存在或資料有誤
        if (err.data.status === '727' || err.data.status === '737') {
          router.replace({ name: 'Error', params: { status: 'activityNotExist' } });
          return;
        }

        router.replace({ name: 'Error', params: { status: 'unstableNetwork' } });
      });
  },
  // 檢查是否為好友導頁
  checkFriendAndRedirect(accountId, companyId, unionId, sourceid, url) {
    const body = {
      companyID: companyId,
      openID: accountId,
    };

    return comService.checkLineOfficeAccountFriend(body)
      .toPromise()
      // 是好友 > 導頁
      .then(() => {
        const data = {
          companyID: companyId,
          memberSourceID: sourceid,
          accountType: 'LineBind',
          accountID: accountId,
        };
        // 紀錄會員或潛客掃碼LOG
        mbcService.PostProspectiveCustomer(data).then((res) => {
          let type = null;
          if (res && (res.response.status === '200' || res.response.status === '609')) {
            type = 1;
          } else if (res && res.response.status === '735') {
            type = 2;
          }
          mmsService.postQrCodeScanningLog({
            unionId, type, memberId: res.response.data[0].memberID, prospectiveCustomerNo: res.response.data[0].prospectiveCustomerNo,
          })
            .toPromise()
            .finally(() => {
              window.location.replace(url);
            })
            .catch(() => {
              this.$router.replace({ name: 'Error', params: { status: 'activityNotExist' } });
            });
        });
      })
      .catch((err) => {
        // 非好友
        if (err.data.status === '605') {
          router.replace({ name: 'AddingLineFriend', params: { redirectUrl: err.data.data[0] } });
          // return;
        }
      });
  },
  // 紀錄並導頁
  redirect(accountId, companyId, unionId, sourceid, url, accountType) {
    const data = {
      companyID: companyId,
      memberSourceID: sourceid,
      accountType,
      accountID: accountId,
    };
    // 紀錄會員或潛客掃碼LOG
    mbcService.PostProspectiveCustomer(data).then((res) => {
      let type = null;
      if (res && (res.response.status === '200' || res.response.status === '609')) {
        type = 1;
      } else if (res && res.response.status === '735') {
        type = 2;
      }
      mmsService.postQrCodeScanningLog({
        unionId, type, memberId: res.response.data[0].memberID, prospectiveCustomerNo: res.response.data[0].prospectiveCustomerNo,
      })
        .toPromise()
        .finally(() => {
          window.location.replace(url);
        })
        .catch(() => {
          this.$router.replace({ name: 'Error', params: { status: 'activityNotExist' } });
        });
    });
  },
};
